"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importStar(require("styled-components"));
var antd_1 = require("antd");
var tagStyles = {
    gray: function () { return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n        background: ", ";\n    "], ["\n        color: ", ";\n        background: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.N8;
    }, function (_a) {
        var theme = _a.theme;
        return theme.color.N4;
    }); },
    magenta: function () { return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "], ["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.M8;
    }, function (_a) {
        var theme = _a.theme;
        return theme.color.M2;
    }); },
    red: function () { return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "], ["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.R8;
    }, function (_a) {
        var theme = _a.theme;
        return theme.color.R2;
    }); },
    volcano: function () { return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: #ffe5da;\n    "], ["\n        border: none;\n        color: ", ";\n        background: #ffe5da;\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.R8;
    }); },
    orange: function () { return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "], ["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.O9;
    }, function (_a) {
        var theme = _a.theme;
        return theme.color.O3;
    }); },
    gold: function () { return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "], ["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.O8;
    }, function (_a) {
        var theme = _a.theme;
        return theme.color.O2;
    }); },
    lime: function () { return styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: #d6f7c1;\n    "], ["\n        border: none;\n        color: ", ";\n        background: #d6f7c1;\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.G7;
    }); },
    green: function () { return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "], ["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.G8;
    }, function (_a) {
        var theme = _a.theme;
        return theme.color.G2;
    }); },
    cyan: function () { return styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "], ["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.T8;
    }, function (_a) {
        var theme = _a.theme;
        return theme.color.T2;
    }); },
    blue: function () { return styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "], ["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.B7;
    }, function (_a) {
        var theme = _a.theme;
        return theme.color.B2;
    }); },
    geekblue: function () { return styled_components_1.css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: #e0ebff;\n    "], ["\n        border: none;\n        color: ", ";\n        background: #e0ebff;\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.B8;
    }); },
    purple: function () { return styled_components_1.css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "], ["\n        border: none;\n        color: ", ";\n        background: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.P8;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colorP2;
    }); }
};
/* tslint:disable:no-string-literal */
exports.Tag = styled_components_1.default(antd_1.Tag)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", ";\n    &.ant-tag-magenta {\n        ", ";\n    }\n    &.ant-tag-red {\n        ", ";\n    }\n    &.ant-tag-volcano {\n        ", ";\n    }\n    &.ant-tag-orange {\n        ", ";\n    }\n    &.ant-tag-gold {\n        ", ";\n    }\n    &.ant-tag-lime {\n        ", ";\n    }\n    &.ant-tag-green {\n        ", ";\n    }\n    &.ant-tag-cyan {\n        ", ";\n    }\n    &.ant-tag-blue {\n        ", ";\n    }\n    &.ant-tag-geekblue {\n        ", ";\n    }\n    &.ant-tag-purple {\n        ", ";\n    }\n"], ["\n    ", ";\n    &.ant-tag-magenta {\n        ", ";\n    }\n    &.ant-tag-red {\n        ", ";\n    }\n    &.ant-tag-volcano {\n        ", ";\n    }\n    &.ant-tag-orange {\n        ", ";\n    }\n    &.ant-tag-gold {\n        ", ";\n    }\n    &.ant-tag-lime {\n        ", ";\n    }\n    &.ant-tag-green {\n        ", ";\n    }\n    &.ant-tag-cyan {\n        ", ";\n    }\n    &.ant-tag-blue {\n        ", ";\n    }\n    &.ant-tag-geekblue {\n        ", ";\n    }\n    &.ant-tag-purple {\n        ", ";\n    }\n"])), tagStyles.gray, tagStyles.magenta, tagStyles.red, tagStyles.volcano, tagStyles.orange, tagStyles.gold, tagStyles.lime, tagStyles.green, tagStyles.cyan, tagStyles.blue, tagStyles.geekblue, tagStyles.purple);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
//# sourceMappingURL=Tag.js.map